import { Colors, Services, getPrice } from '@sigma-frontend-libs/commons'
import { BILLING_CURRENCY } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components, icons, labelModes, popperPlacements, sizes } from '@/utils'

import button from '@/components/button'
import tag from '@/components/tag'

function renderLimitTag(h) {
  const { balance, includeOverdraft } = this.proxy

  return h(
    tag,
    {
      props: {
        label: this.getLabel(balance, includeOverdraft, this.path)
      }
    }
  )
}
function renderLimitButton(h) {
  return h(
    button,
    {
      props: {
        icon: icons.edit,
        mode: buttonModes.flat,
        size: sizes.small
      },
      slot: 'activator'
    }
  )
}
function renderLimitField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.balance,
        label: this.getTranslate(`${Services.settingsUser}.labels.${this.path}.limit`),
        defaultValue: 0,
        clearable: true,
        autofocus: true,
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        suffix: this.getTranslate(`currency.${this.currency}.symbol.unicode`),
        type: 'number',
        step: 'any'
      },
      on: {
        input: event => {
          this.proxy.balance = event
        }
      }
    }
  )
}
function renderLimitMenu(h) {
  if (this.permission !== 'read') {
    return h(
      components.menu,
      {
        props: {
          closeOnContentClick: false,
          transparent: true,
          maxWidth: 150,
          offsetDistance: 8,
          placement: popperPlacements.right
        }
      },
      [
        renderLimitButton.call(this, h),
        renderLimitField.call(this, h)
      ]
    )
  }
}
function renderPanelHeader(h) {
  return h(
    'div',
    {
      class: `${Services.settingsUser}-${Services.notifications}-events-balance-limit__panel-header`
    },
    [
      renderLimitTag.call(this, h),
      renderLimitMenu.call(this, h)
    ]
  )
}
function renderOverdraftButton(h) {
  let overdraftLabelKey
  let overdraftColor
  if (this.proxy.includeOverdraft) {
    overdraftLabelKey = 'include'
    overdraftColor = Colors.success
  } else {
    overdraftLabelKey = 'notInclude'
    overdraftColor = Colors.error
  }
  const label = this.getTranslate(`${Services.settingsUser}.labels.${this.path}.${overdraftLabelKey}.overdraft`)
  const color = overdraftColor
  const size = sizes.tiny
  if (this.permission === 'read') {
    return h(
      tag,
      {
        props: {
          label,
          color,
          size,
          as: 'button'
        }
      }
    )
  }

  return h(
    button,
    {
      props: {
        label,
        size,
        color,
        mode: buttonModes.flat
      },
      on: {
        click: () => {
          this.proxy.includeOverdraft = !this.proxy.includeOverdraft
        }
      }
    }
  )
}
function renderInvoiceButton(h) {
  if (this.currency === BILLING_CURRENCY.RUB) {
    let label = ''
    if (this.proxy.invoice) {
      const amount = this.proxy?.invoice?.data?.SERVICE_PRICE
      if (amount) {
        let invoicePermissionKey
        if (this.permission === 'read') {
          invoicePermissionKey = 'send'
        } else {
          invoicePermissionKey = 'detach'
        }
        label = this.getTranslate(`${Services.settingsUser}.labels.${this.path}.include.invoice.${invoicePermissionKey}`, { amount: getPrice(amount, { currency: BILLING_CURRENCY.RUB }) })
      }
    } else {
      label = this.getTranslate(`${Services.settingsUser}.buttons.${this.path}.invoice.attach`)
    }
    let invoiceColor
    if (this.proxy.invoice) {
      invoiceColor = Colors.warning
    } else {
      invoiceColor = Colors.primary
    }
    const color = invoiceColor
    const size = sizes.tiny

    if (this.permission === 'read') {
      if (this.proxy.invoice) {
        return h(
          tag,
          {
            props: {
              label,
              color,
              size,
              as: 'button'
            }
          }
        )
      }
    } else {
      return h(
        button,
        {
          props: {
            label,
            size,
            color,
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              if (!this.proxy.invoice) {
                this.$emit('dialog', true)
              } else {
                this.proxy.invoice = false
              }
            }
          }
        }
      )
    }
  }
}
function renderPanelFooterButtons(h) {
  return h(
    'div',
    {
      class: `${Services.settingsUser}-${Services.notifications}-events-balance-limit__panel-footer-buttons`
    },
    [
      renderOverdraftButton.call(this, h),
      renderInvoiceButton.call(this, h)
    ]
  )
}
function renderPanelRemoveButton(h) {
  if (this.permission !== 'read') {
    return h(
      'div',
      {
        class: 'fjcfe'
      },
      [
        h(
          button,
          {
            props: {
              label: this.getTranslate('misc.buttons.remove'),
              mode: buttonModes.flat,
              size: sizes.tiny,
              color: Colors.error
            },
            on: {
              click: () => {
                this.$emit('remove', this.index)
              }
            }
          }
        )
      ]
    )
  }
}
function renderPanelFooter(h) {
  return h(
    'div',
    {
      class: `${Services.settingsUser}-${Services.notifications}-events-balance-limit__panel-footer`
    },
    [
      renderPanelFooterButtons.call(this, h),
      renderPanelRemoveButton.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.settingsUser}-${Services.notifications}-events-balance-limit__panel`]: true,
        [`${Services.settingsUser}-${Services.notifications}-events-balance-limit__panel--read`]: this.permission === 'read',
        [`${Services.settingsUser}-${Services.notifications}-events-balance-limit__panel--invoice`]: this.proxy.invoice
      }
    },
    [
      renderPanelHeader.call(this, h),
      renderPanelFooter.call(this, h)
    ]
  )
}
